import axios from 'axios'

const API_PATH = 'admins/marketing/discount_batches/items'

const MarketingDiscountBatchesItemsApi = {
  /**
   * Get marketing discount batch items.
   * Invoke `GET /admins/marketing/disocunt_batches/items`
   * @param {Object} params - can contain :
      * @param {number} batch_id - `Marketing::DiscountBatch` id
      * @param {string} sku - sku of discount batch item that want to be shown
      * @param {string} status - status of `Marketing::DiscountBatch::Item`
      * @param {number} page - page no
      * @param {number} per_page - items shown per page
   */
  get: async(
    params
  ) => {
    const path       = `${API_PATH}`
    const api_params = {
      ...params
    }

    const response = axios.get(path, api_params )
    return response
  },

  /**
   * Cancel `Marketing::DiscountBatch::Item` with status `scheduled`
   * Invoke `GET /admins/marketing/disocunt_batches/items/:id/cancel`
   * @param {number} id - id of Marketing::DiscountBatch::Item that want to be cancelled before job run
   */
  cancel: async(
    id
  ) => {
    const path     = `${API_PATH}/${id}/cancel`
    const response = axios.patch(path)
    return response
  },

  /**
   * Remove `Marketing::DiscountBatch::Item` with status `live`
   * Invoke `GET /admins/marketing/disocunt_batches/items/:id/cancel`
   * @param {number} id - id of `Marketing::DiscountBatch::Item` that want to be cancelled after the job run and before job expired
   */
  remove: async(
    id
  ) => {
    const path     = `${API_PATH}/${id}/remove`
    const response = axios.patch(path)
    return response
  }
}

export default MarketingDiscountBatchesItemsApi
